import React, {Component} from "react";
import styled from 'styled-components';

const BotonLink = styled.button`
    color: #337ab7;
    border-radius: 0;
    font-weight: normal;
    background-color: transparent;
    border-color: transparent;
    padding: 0px;
    width: 100%;
    &:hover {
        border-color: transparent;        
        text-decoration: underline;
    };
    &:focus {
        border-color: transparent;        
    };
    &:active {
        border-color: transparent;        
    };
`;


export default class LinkModalRenderer extends Component {
    constructor(props) {
        super(props);
            this.invokeParentMethod = this.invokeParentMethod.bind(this);
            this.validateState = this.validateState.bind(this);
            this.name = this.name.bind(this);
    }

    //Funcion a Ejecutar el control
    invokeParentMethod() {
        
        this.props.context.componentParent.methodDeployFromParent(this.props.node.id, this.props.node.data)
    }

    //Funcion para validar el estado del control
    validateState() {
        console.log("DATA: ",this.props.node.data)
        return this.props.context.componentParent.methodValidateFromParent(this.props.node.data) 
    }

    name(){
        return this.props.context.componentParent.methodNameFromParent(this.props.node.data)
    }

    render() {
        return (
            <span><BotonLink type="button" onClick={this.invokeParentMethod} disabled={this.validateState()}>{this.name()}</BotonLink></span>
        );
    }


};